module.exports = __webpack_public_path__ + "static/img/143_phase_function_Paper_PointsHejduk_Prediction.053ba18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/143_phase_function_Paper_PointsHejduk_Prediction.png
// module id = M/Hs
// module chunks = 0